<template>
  <v-alert type="success" prominent dense dismissible border="left" :value="flag" @input="onInput">
    <strong>{{ message }}</strong>
  </v-alert>
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import Store from '@/store';
import { undoSuccess } from '@/libs/store/success';

const props = Vue.extend({
  props: {
    messages: { type: Object, default: {} },
  },
});

@Component
export default class SuccessMessage extends props {
  get flag(): boolean {
    return Store.getters.success.flag;
  }

  get msg(): string {
    return Store.getters.success.msg;
  }

  get message(): string {
    if (this.flag) {
      const msg = this.msg;
      return this.messages[msg] || msg;
    }
    return '';
  }

  private onInput(flag: boolean) {
    if (!flag) {
      undoSuccess();
    }
  }
}
</script>
